import { useQuery } from '@tanstack/react-query';
import { get } from '@/shared/api/api-client';
import type { Patient } from '@/types/patient-api';

/** GET /api/Patients/{patientId} — full patient detail for the edit screen. */
export function usePatient(patientId: string | null | undefined) {
  return useQuery({
    queryKey: ['patient', patientId],
    queryFn: ({ signal }) => get<Patient>(`/api/Patients/${patientId}`, { signal }),
    enabled: !!patientId,
  });
}
